import React, { ReactNode } from 'react';

import { logCritical } from '@savgroup-front-common/configuration/src/appInsights/AppInsights';

import { buildPageTitle } from '../../helpers';

import ChunkLoadErrorBoundary from './ChunkLoadErrorBoundary';
import ErrorBoundyTemplate from './ErrorBoundyTemplate';
import messages from './messages';

class AppErrorBoundary extends React.Component<
  { home?: string; children: ReactNode },
  { hasError: boolean; hasChunkLoadError: boolean; errorMessage?: string }
> {
  constructor(props: { home?: string; children: ReactNode }) {
    super(props);
    this.state = {
      hasError: false,
      hasChunkLoadError: false,
    };
  }

  componentDidCatch(error: any, errorInfo: any) {
    const errorMessage = error?.message;

    if (error && errorMessage?.includes('Loading chunk')) {
      this.setState({ hasChunkLoadError: true });
    } else {
      this.setState({ hasError: true, errorMessage });

      logCritical(error, { errorInfo });

      document.title = buildPageTitle([messages.title]);
    }
  }

  render() {
    const { children, home } = this.props;
    const { hasError, hasChunkLoadError, errorMessage } = this.state;

    if (hasChunkLoadError) {
      return <ChunkLoadErrorBoundary />;
    }

    if (hasError) {
      return (
        <ErrorBoundyTemplate
          isFullScreen
          home={home}
          errorMessage={errorMessage}
        />
      );
    }

    return children;
  }
}

export default AppErrorBoundary;
